<template>
    <div
        v-if="readOnlyOrLocked && !useTextareaReadonly"
        class="w-full resize-none overflow-hidden overflow-x-auto whitespace-nowrap shadow-none relative"
        v-text="effectiveFormat(value)"
        @mouseenter="$emit('mouseenter', $event)"
        @click="$emit('click', $event)"
        @mouseleave="$emit('mouseleave', $event)"
    ></div>
    <textarea v-else-if="readOnlyOrLocked && useTextareaReadonly"
              class="text-gray-600 m-0 px-1 py-1 border border-gray-200 resize-none overflow-hidden overflow-x-auto whitespace-nowrap shadow-none relative hover:border hover:border-gray-200 cursor-text"
              style="cursor:auto !important"
              rows="1"
              disabled
              @mouseenter="$emit('mouseenter', $event)"
              @click="$emit('click', $event)"
              @mouseleave="$emit('mouseleave', $event)"
              :value="effectiveFormat(value)"
    ></textarea>
    <textarea
        v-else
        :placeholder="placeholder"
        type="text"
        autocomplete="off"
        class="resize-none overflow-hidden overflow-x-auto whitespace-nowrap shadow-none relative hover:z-10 focus:z-20"
        :value="focused ? value : effectiveFormat(value)"
        @input="$emit('input', $event.target.value)"
        @change="$emit('change', $event.target.value)"
        @keydown.enter.prevent="$emit('change', $event.target.value);$event.target.blur()"
        @keydown="$emit('keydown', $event)"
        @focus="focused = true; selectAll($event); $emit('focus', $event)"
        @blur="$emit('blur', $event); focused = false"
        @mouseenter="$emit('mouseenter', $event)"
        @mouseleave="$emit('mouseleave', $event)"
        rows="1"
    ></textarea>
</template>

<script>
import {toCurrency} from '@utils'

export default {
    props: {
        value: null,
        placeholder: String,
        currency: Boolean,
        decimals: {
            type: Number,
            default: 2,
        },
        readOnly: Boolean,
        format: {
            type: Function,
            default: value => value,
        },
        useTextareaReadonly: {type: Boolean, default: false},
    },
    data() {
        return {
            focused: false,
            selectAllDisabled: false,
        }
    },
    computed: {
        readOnlyOrLocked() {
            return this.readOnly
        },
    },
    methods: {
        focusAsNew() {
            this.disableSelectAll();
            this.$el.focus()
            this.enableSelectAll();
        },
        effectiveFormat(value) {
            return this.currency ? toCurrency(value, 'GBP', this.decimals) : this.format(value)
        },
        disableSelectAll() {
            this.selectAllDisabled = true
        },
        enableSelectAll() {
            this.selectAllDisabled = false
        },
        selectAll(event) {
            if (this.selectAllDisabled) {
                return;
            }
            // Work around unselect on mouseup issue on Safari.
            this.$el.addEventListener('mouseup', this.remove, {once: true})

            this.$nextTick(() => {
                event.target.setSelectionRange(0, event.target.value.length)

                // Work around Safari's delay when focusing elements.
                setTimeout(() => {
                    event.target.setSelectionRange(0, event.target.value.length)
                }, 10);
            })
        },
        remove(event) {
            event.preventDefault()
            event.stopPropagation()
            this.$el.removeEventListener('mouseup', this.remove, {once: true})
            return false
        },
        beforeUnmount() {
            this.$el.removeEventListener('mouseup', this.remove, {once: true})
        }
    },
}
</script>
